<script>
    import R, {LOADER} from "../../lib/requests";
    import {createEventDispatcher} from 'svelte/internal';
    import PriceControl from "../../components/controls/PriceControl.svelte";
    import AppIcon from "../../components/icons/AppIcon.svelte";
    import Notifier from "../../stores/notifier";
    import Alert from "../../stores/alerts";

    export let shipping;

    let name = shipping.name;
    let isDirty = false;

    const dispatch = createEventDispatcher();

    const save = () => {
        const onSuccess = result => {
            shipping.id = result.id;
            shipping.name = result.name;
            isDirty = false;
            Notifier.showMessage("Η ζώνη ενημερώθηκε");
        }

        const onFailure = err => {
        };

        name = name.trim();
        if (!name) {
            Notifier.showError("Πληκτρολογήστε το όνομα της ζώνης μεταφορικών!");
            return;
        }

        shipping.name = name;
        let action = shipping.id == 0 ? 'create' : 'edit';
        R.handle(R.shipping[action], shipping, onSuccess, onFailure, LOADER.POPUP);
    }

    const onChange = () => {
        isDirty = true;
    }

    const addPrice = () => {
        shipping.prices = [...shipping.prices, {
            min_weight: null,
            max_weight: null,
            price: 0,
        }];
    }

    const onDeletePrice = index => {
        Alert.delete("Διαγραφή τιμής", `Να διαγραφεί η βαθμίδα τιμής από τα μεταφορικά "<b>${shipping.name}</b>";`, () => deletePrice(index));
    }

    const deletePrice = index => {
        shipping.prices.splice(index, 1);
        shipping.prices = shipping.prices;
        isDirty = true;
    }

    const onDelete = () => {
        dispatch('delete', shipping);
    }
</script>

<tr>
    <td class="name-column p-1">
        <input type="text" class="form-control form-control-immediate"
               bind:value="{ name }" on:change={ onChange }>
    </td>
    <td class="p-1">
        <input type="number" class="form-control form-control-immediate"
               bind:value="{ shipping.extra_weight }" placeholder="γραμμάρια" on:change={ onChange }>
    </td>
    <td class="p-1">
        <PriceControl cssClass="form-control-immediate" bind:value="{ shipping.extra_price }" on:change={ onChange }/>
    </td>
    <td class="p-1">
        <PriceControl cssClass="form-control-immediate" bind:value="{ shipping.max_price }" on:change={ onChange }/>
    </td>
    <td class="button-column pointer" title="διαγραφή ζώνης" on:click={ onDelete }>
        <AppIcon icon="trash" strokeWidth="2" size="16"/>
    </td>
</tr>
<tr class="edit-row">
    <td class="p-0 no-border">&nbsp;</td>
    <td colspan="4" class="pt-1 ps-0 pe-0">
        <table class="table table-list table-sm table-prices">
            <thead>
            <th>Βάρος (γρ) από</th>
            <th>έως</th>
            <th>Τιμή</th>
            <th>
                <div class="btn btn-link" title="προσθήκη βαθμίδας" on:click={ addPrice }>
                    <AppIcon icon="plus-circle" strokeWidth="2" size="14"/>
                </div>
            </th>
            </thead>
            <tbody>
            {#each shipping.prices as item, index}
                <tr>
                    <td class="p-1">
                        <input type="number" class="form-control form-control-immediate"
                               bind:value="{ item.min_weight }" placeholder="γραμμάρια" on:change={ onChange }>
                    </td>
                    <td class="p-1">
                        <input type="number" class="form-control form-control-immediate"
                               bind:value="{ item.max_weight }" placeholder="γραμμάρια" on:change={ onChange }>
                    </td>
                    <td class="p-1">
                        <PriceControl cssClass="form-control-immediate" bind:value="{ item.price }"
                                      on:change={ onChange }/>
                    </td>
                    <td class="button-column pointer" title="διαγραφή βαθμίδας" on:click={ () => onDeletePrice(index) }>
                        <AppIcon icon="trash" strokeWidth="2"/>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        {#if isDirty}
            <div class="panel-simple border-none p-2 text-end">
                <button class="btn btn-xs btn-danger" on:click={ save }>ενημέρωση</button>
            </div>
        {/if}
    </td>
</tr>

<style>
    .name-column {
        width: 200px;
    }

    .table-prices th {
        padding: 5px 15px;
        vertical-align: middle;
    }
</style>